import GetStartedSponsors from "../screen/container/get-started/sponsors/get-started-sponsors";

export const routesSponsors = [
    {
        path: "/get-started-sponsors",
        exact: true,
        component: GetStartedSponsors,
        guard: "public",
    },
];